const generatePdfDropdownToggle = document.getElementById('generatePdfDropdownToggle');
const generatePdfDropdownMenu = document.getElementById('generatePdfDropdownMenu');

if (generatePdfDropdownToggle && generatePdfDropdownMenu) {
    toggleDropdown(generatePdfDropdownToggle, generatePdfDropdownMenu);

// Collapse windows when clicking outside
    window.addEventListener('click', function(e) {
        if (e.target !== generatePdfDropdownMenu && !generatePdfDropdownMenu.contains(e.target)) {
            if (e.target !== generatePdfDropdownToggle && !generatePdfDropdownToggle.contains(e.target)) {
                if (!generatePdfDropdownToggle.classList.contains('collapsed')) {
                    generatePdfDropdownToggle.classList.add('collapsed');
                    generatePdfDropdownMenu.classList.add('collapsed');
                }
            }
        }
    });

    function toggleDropdown(toggle, menu) {
        if (toggle && menu) {
            toggle.addEventListener('click', function(e) {
                if (e.target == toggle && toggle.classList.contains('collapsed')) {
                    setTimeout(function() {
                        toggle.classList.toggle('collapsed');
                        menu.classList.toggle('collapsed');
                    }, 50);
                }

                collapseAll();
            });
        }
    }

    document.querySelectorAll('li.pdf').forEach(selector => {
        if (selector) {
            selector.addEventListener('click', (item) => {
                const form = selector.querySelector('form');
                form.submit();

                item.target.classList.add('loading');
                item.target.innerHTML = 'Laster ...';
                item.target.disabled = true;
                setTimeout(() => {
                    item.target.classList.remove('loading');
                    item.target.innerHTML = item.target.name;
                    item.target.disabled = false;
                    collapseAll();
                }, 10 * 1000); // 10 sec
            });
        }
    });

    function collapseAll() {
        generatePdfDropdownToggle.classList.add('collapsed');
        generatePdfDropdownMenu.classList.add('collapsed');
    }
}
